import { useTranslation } from "react-i18next";
import { DueRow } from "./DueRow";

export const DuesList = ({ items, onOpen }) => {
  const { t } = useTranslation();
  if (!items?.length) {
    return (
      <p className="mt-4 rounded-3xl bg-background/60 p-6 text-center text-sm text-muted-foreground"
         data-testid="dues-empty">
        {t("acct.dues.empty")}
      </p>
    );
  }
  return (
    <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-3" data-testid="dues-list">
      {items.map((row) => (
        <DueRow key={row.id} row={row} onOpen={onOpen} />
      ))}
    </div>
  );
};
